import { isNotFound } from './apiError';
import { post } from './request';

const baseUrl = process.env.REACT_APP_COCALERO_API_URL + `/v2/web/user_friends`;

export type FriendListResponse = {
    id: number;
    user_image: string;
    name: string;
};

export const userFriendApi = {
    batchGet: (friendIds: number[]): Promise<FriendListResponse[]> =>
        post(baseUrl + '/search', {
            user_friends: {
                offset: 0,
                limit: friendIds.length,
                to_id: friendIds,
            },
        })
            .then((res: { friends: FriendListResponse[] }) => res.friends)
            .catch((err: Error) => {
                if (isNotFound(err)) {
                    return Promise.resolve([]);
                }
                return Promise.reject(err);
            }),
};
